<template>
	<div class="c-tip">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'cTip'
	}
</script>

<style lang="stylus" scoped>
	.c-tip {
		z-index: 11;
		position: sticky;
		top: 0;
		padding: 10px 20px;
		line-height: 16px;
		font-size: 12px;
		color: #f55;
		background: #fff9f9;
	}
</style>